import React, { ReactNode } from "react";
import ReactModal, { Props, Styles } from "react-modal";
import { useBreakpoint } from "../../hooks/useBreakpoint";

interface ModalProps extends Props {
  children: ReactNode;
}

ReactModal.setAppElement("#___gatsby");

function Modal({ children, ...rest }: ModalProps) {
  const { width } = useBreakpoint();

  const objStyle: Styles = {
    content: {
      position: "static",
      zIndex: 10000,
      maxWidth: 640,
      margin: "0 auto",
      width: "100%",
      padding: "1.5rem",
      inset: 0,
      overflowY: "auto",
      maxHeight: width < 769 ? "100%" : "95%",
      borderRadius: 16
    },
    overlay: {
      display: "flex",
      alignItems: width < 769 ? "stretch" : "center",
      justifyContent: "center",
      zIndex: 10001,
      backgroundColor: "rgba(0,0,0,0.32)",
    },
  };

  return (
    <ReactModal style={objStyle} {...rest}>
      {children}
    </ReactModal>
  );
}

export { Modal };
